import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tw--modal"
export default class extends Controller {
  connect() {
  }
}
